import { TabidooTablePage } from '@/components/vyroba/TabidooTablePage';

/** Databáze produktů — zrcadlo Tabidoo tabulky „databazeproduktu" (spojuje kategorie, látky, nitě). */
export function DatabazeProduktuPage() {
  return (
    <TabidooTablePage
      table="produkty"
      storagePrefix="produkty"
      title="Databáze produktů"
      subtitle="Zrcadlo z Tabidoo. Hledej globálně, filtruj po sloupcích, přehazuj a měň šířku sloupců. Klikni na řádek pro detail a editaci."
      createLabel="Nový produkt"
    />
  );
}
